import React from 'react';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import Navbar from '../components/navbar/Navbar';

// import BottomChat from '../components/messenger/BottomChat';
import HeaderCtaAds from '../components/HeaderCtaAds';
import Footer from '../components/Footer';
import {fetchCurrentUser} from '../../creators/currentUser';
import Disclaimer from "../pages/disclaimer/Disclaimer";
import {bindActionCreators} from "redux";
import createLink from "../../libs/createLink";

import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Authenticated from "../../libs/Authenticated";
import {Button} from "../components/Button";
import EmailValidation from "../components/SignUpInformation/components/EmailValidation";
import _ from "lodash";
import Cookies from 'universal-cookie';
//import Mailto from "../components/MailTo";
//import Icon from "../components/Icon";
import {isBot} from "../../libs/helper";
import {GrosPlanProvider} from "../../libs/contextBigPlan";
import {updateCurrentUserToggleBigPlan} from "../../creators/currentUser.toggleBigPlan";
import {PageLoader} from "../components/Loader";
import {fetchIsTool} from "../../creators/isTool";
import Icon from "../components/Icon";


const cookies = new Cookies();

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.props.fetchIsTool({
            userAgent : window.navigator.userAgent,
            language : window.navigator.language,
            platform : window.navigator.platform
        });
        if(window.location.hash.match(/[#&](nodisclaimer)/)){
            cookies.set('DISCLAIMED', 'accepted',{expire:0});
            let hash = window.location.hash.replace(/(.*)[#&]nodisclaimer(.*)/, '$1$2');
            if(hash !== ""){
                if(hash.substr(0,1) === "&"){
                    hash = hash.substr(1,hash.length);
                }
                if(hash.substr(0,1) !== "#"){
                    hash = `#${hash}`;
                }
            }
            let newUri = window.location.pathname + window.location.search + hash;
            window.history.replaceState({}, document.title, newUri);
        }

        this.token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
        let hasAcceptedDisclaimer = isBot || cookies.get('DISCLAIMED') || false;


        this.state = {
            hasAcceptedDisclaimer: this.token ? true : hasAcceptedDisclaimer,
            toggleModalEmailUnconfirmed: false,
            isToolInitialized : false,
            //isAuth : this.props.currentUserInitialized || false
            toggleModalAv : sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_article`) ? false : true
        };
        this.handleBlur = this.handleBlur.bind(this);

       this.onCloseAv = this.onCloseAv.bind(this);

        if (this.token) {
            this.props.fetchCurrentUser();
        }
/*
        if (this.props.currentUserInitialized) {
            this.props.getRoles();
        }*/


    }

    static propTypes() {
        return {
            match: PropTypes.object.isRequired,
            location: PropTypes.object.isRequired,
            history: PropTypes.object.isRequired
        }
    }


    handleBlur() {
        this.setState({hasAcceptedDisclaimer: true})
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.currentUserError?.statusCode === 404){
            this.token = null;
        }
        if(this.props.isToolInitialized && !this.state.isToolInitialized){
            this.setState({isToolInitialized : true});
        }


       /* if(prevState.isAuth !== this.props.currentUserInitialized){
            this.setState({isAuth : this.props.currentUserInitialized}, ()=>{
                this.context.setFilterToggle({isAuth: this.props.currentUserInitialized})
            })
        }*/

    }


    shouldComponentUpdate(nextProps, nextState, nextContext) {
        /*if(nextState.isAuth !== this.state.isAuth){
            return true;
        }*/
        if(nextProps.children !== this.props.children){
            return true;
        }
        if(nextProps.location !== this.props.location){
            return true;
        }
        if(nextProps.match !== this.props.match){
            return true;
        }
        if(nextProps.currentUserInitialized !== this.props.currentUserInitialized){
            return true;
        }
        if(nextProps.currentUserError !== this.props.currentUserError){
            return true;
        }

        if(_.get(nextProps.currentUser,"setting.displayBigPlan") !== _.get(this.props.currentUser, "setting.displayBigPlan")){
            return true;
        }
        if(_.get(nextProps.currentUser,"email.newMail") !== _.get(this.props.currentUser, "email.newMail")){
            return true;
        }

        if(this.state.hasAcceptedDisclaimer !== nextState.hasAcceptedDisclaimer){
            return true;
        }
        if(this.state.toggleModalEmailUnconfirmed !== nextState.toggleModalEmailUnconfirmed){
            return true;
        }
        if(this.state.isToolInitialized !== nextState.isToolInitialized){
            return true;
        }
        if(nextProps.isToolInitialized !== this.props.isToolInitialized){
            return true;
        }

        if(this.state.toggleModalAv !== nextState.toggleModalAv){
            return true;
        }

        return false;
    }

    onCloseAv(){
        this.setState({toggleModalAv : false}, ()=>{
            sessionStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_article`, true);
        });
    }

    render() {
        let showHeaderCtaAds = (this.props.location && this.props.location.pathname === '/');// ([createLink("messenger"), '/user', '/User', createLink("actuality"), '/user-albums', '/gallery-album', '/user-informations', '/user-articles', createLink("signin"), createLink("signup"), createLink("dating"), '/forgot-password', '/404'].indexOf(this.props.location.pathname) === -1);
        let showHeaderBgHeart = ([createLink("messenger"), '/user', '/User', createLink("actuality"), '/user-albums', '/gallery-album', '/user-informations', '/user-articles', createLink("dating"), '/moderation'].indexOf(this.props.location.pathname) === -1);
        let showHotContent = ([createLink("messenger")].indexOf(this.props.location.pathname) === -1 && !RegExp('/mediaviewer/*').test(this.props.location.pathname));
        let showOnlyView = ([createLink("signin"), createLink("signup")].indexOf(this.props.location.pathname) === -1);
        //Patch Gregory, close emoticon for comments after click
/*        window._checkSmileyPopoverInterval = setInterval(function() {
            let popover = document.querySelector('.emojiSelectPopover:not(.patched)');
            if ( !popover ) {
                return;
            }
            popover.querySelectorAll('.emojiSelectPopoverEntry').forEach(function(element) {
                element.addEventListener('click', function() {
                    document.body.click();
                });
            });
            popover.classList.add('patched');
        }, 100);*/

        //soit aucun token, soit token et Initialized

        let initUser = (!this.token || (this.token && this.props.currentUserInitialized));
        window.setTimeout(()=>{
            if(!this.state.isToolInitialized){
                this.setState({isToolInitialized : true});
            }
        }, 3000)
        //let linkSondage = this.props.currentUserInitialized ? "https://docs.google.com/forms/d/10XrCKXht7BZuSGoDoVaqAoL64xmcL2HxxrZgIUZfvHo" : "https://docs.google.com/forms/d/17A95_Rda5-HnQDIGSLVH7QxVeJVcb_h_4PdM_aMXLN4";
        return (
            <main className={`${showHeaderBgHeart && showHeaderCtaAds ? 'bgHeart' : ''} ${!showOnlyView ? 'bgHeart' : ''}`}>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    closeOnClick
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <Disclaimer isTool={this.props.isTool} isToolInitialized={this.state.isToolInitialized} handleBlur={this.handleBlur} hasAcceptedDisclaimer={this.state.hasAcceptedDisclaimer}/>
                <Navbar showHotContent={showHotContent}
                        showOnlyView={showOnlyView}
                        token={this.token}
                        location={this.props.location}
                />

                {this.props.currentUserInitialized && this.state.toggleModalAv ? (
                    <div className="alert-bar info-beta">
                        <span className="danger-bar-message">
                            <div>URGENT / Une charte remaniée c’est bien, une charte appliquée c’est mieux ! Soyez pro actifs en lisant <a target={"_blank"} style={{fontWeight : "bold"}} rel="noopener noreferrer" href={"https://www.voissa.com/blog-sexe-amateur/esprit-voissa/a-lire-tres-important-application-de-la-charte-voissa-dans-vos-albums_63cd70353a36a4337fc2bf51"}>cet article</a> !!</div>
                        </span> <div style={{paddingLeft : "10px"}} onClick={()=>this.onCloseAv()}  ><Icon type={"close"} className={"cursor-pointer"} /></div>
                    </div>
                ) : null}
                <Authenticated passThrough>
                    {(authenticated) => {
                        return !authenticated && this.props.location.pathname !== "/page-introuvable" ? (
                            showHeaderCtaAds && !this.token && <HeaderCtaAds/>
                        ) : this.props.location.pathname === createLink("signin") || this.props.location.pathname === createLink("signup") || this.props.location.pathname === createLink("dating") || this.props.location.pathname === createLink("forgotPassword") ? (
                            ''
                        ) : ''
                    }}
                </Authenticated>
                {
                    !this.props.location.pathname.includes('first-connexion') &&
                    _.get(this.props.currentUser, "email.bounced")
                    ? (
                        <div className="alert-bar">
                            <span className="alert-bar-message">Votre adresse email semble invalide, <Link
                                to={createLink("userMeSettingsEmailAndPassword")}>cliquez ici pour la modifier.</Link></span>
                        </div>
                    )
                    : null
                }
                {!this.props.location.pathname.includes('first-connexion')
                && this.props.currentUser
                && this.props.currentUser.role === "emailUnconfirmed"
                 ? (
                    <div className="alert-bar" onClick={() => this.setState({toggleModalEmailUnconfirmed: true})}>
                        <span className="alert-bar-message">
                            Merci de confirmer votre email afin de pouvoir utiliser toutes les
                        fonctionnalités du site
                        </span>
                        <Button className="danger"
                                size={"small"}
                                content="Confirmer"/>
                    </div>
                ) : null}


                <EmailValidation
                    toggle={this.state.toggleModalEmailUnconfirmed}
                    handleClose={() => this.setState({toggleModalEmailUnconfirmed: false})}
                    avatar={_.get(this.props.currentUser, 'profile.avatar')}
                    gender={_.get(this.props.currentUser, 'profile.gender')}
                    email={this.props.currentUser && this.props.currentUser.email && this.props.currentUser.email.address}/>
                <div id="view" >
                    {initUser ? (
                        <GrosPlanProvider
                            isToggle={localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_gp`) === "true" ? true : false}
                            isAuth={this.props.currentUserInitialized}
                            updateCurrentUserToggleBigPlan={this.props.updateCurrentUserToggleBigPlan}
                        >
                            {this.props.children}
                        </GrosPlanProvider>
                    ) : (
                        <PageLoader />
                    )}

                </div>
                {/*<Authenticated passThrough>
                    {(authenticated) => {
                        return authenticated && (
                            (!RegExp(`${createLink("messenger")}/*`).test(this.props.location.pathname) && !RegExp('/(xxx-photos|xxx-videos)/*').test(this.props.location.pathname)) &&
                            <Can action={"read"} subject="Room"><BottomChat/></Can>
                        )
                    }}
                </Authenticated>*/}
                {/*!RegExp(`${createLink("messenger")}/*`).test(this.props.location.pathname) ? <Mailto
                    className={"mail-to"}
                    email="esprit@voissa.com"
                    subject="Mes retours sur la V2"
                    body={`Ecrivez-nous votre problème dans cet email avec un maximum de détails (votre pseudo, votre navigateur, ordinateur ou mobile, etc.) :`}
                >
                </Mailto> : null */}
                {!RegExp(`${createLink("messenger")}/*`).test(this.props.location.pathname) &&
                !RegExp(`xxx-photos/*`).test(this.props.location.pathname) &&
                !RegExp(`xxx-videos/*`).test(this.props.location.pathname) &&
                showHotContent && showOnlyView && this.props.location.pathname !== createLink("actuality") &&
                <Footer {...this.props} />}
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserInitialized: state.currentUser.initialized,
        currentUserLoading: state.currentUser.loading,
        currentUserError : state.currentUser.error,

        isTool: state.isTool.data,
        isToolInitialized: state.isTool.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUserToggleBigPlan,
    fetchIsTool
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));
